module.exports = __webpack_public_path__ + "064ff0b82b0fc6e5169181456ad9acab.svg";